import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { config } from '_config';
import { WebhookService } from '_services';
import { processResponse, processError } from '_helpers/api';
import { getHostname } from '_helpers/common';

export const getGeolocation = createAsyncThunk(
  'general/getGeolocation',
  async function (_, { dispatch, rejectWithValue }) {
    try {
      WebhookService.token = config.webhookIPKey;
      const response = await WebhookService.ip();
      return processResponse(response);
    } catch (e) {
      const processedError = processError(e);
      dispatch(
        sendMessageToSlack({
          channel: 'ip-service-issues',
          message: `HOSTNAME: ${getHostname()} | ERROR: ${
            processedError?.message || 'Something went wrong...'
          }`,
        })
      );
      return rejectWithValue(processError);
    }
  }
);

export const sendMessageToSlack = createAsyncThunk(
  'general/sendMessageToSlack',
  async function ({ channel, message }, { rejectWithValue }) {
    try {
      WebhookService.token = config.webhookSlackKey;
      const response = await WebhookService.slack({ channel, message });
      return processResponse(response);
    } catch (e) {
      return rejectWithValue(processError(e));
    }
  }
);

const generalSlice = createSlice({
  name: 'general',
  initialState: {
    device: null,
    salePageURL: null,
    geolocation: {
      data: null,
      error: null,
      loading: false,
    },
    slackMessage: {
      success: false,
      error: null,
      loading: false,
    },
  },
  reducers: {
    refreshDevice(state, action) {
      state.device = action.payload;
    },
    refreshSalePageURL(state, action) {
      state.salePageURL = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getGeolocation.pending, (state) => {
        state.geolocation.error = null;
        state.geolocation.loading = true;
      })
      .addCase(getGeolocation.fulfilled, (state, action) => {
        state.geolocation.data = action.payload;
        state.geolocation.loading = false;
      })
      .addCase(getGeolocation.rejected, (state, action) => {
        state.geolocation.error = action.payload;
        state.geolocation.loading = false;
      });

    builder
      .addCase(sendMessageToSlack.pending, (state) => {
        state.slackMessage.error = null;
        state.slackMessage.success = false;
        state.slackMessage.loading = true;
      })
      .addCase(sendMessageToSlack.fulfilled, (state, action) => {
        state.slackMessage.success = true;
        state.slackMessage.loading = false;
      })
      .addCase(sendMessageToSlack.rejected, (state, action) => {
        state.slackMessage.error = action.payload;
        state.slackMessage.success = false;
        state.slackMessage.loading = false;
      });
  },
});

export const { refreshDevice, refreshSalePageURL } = generalSlice.actions;

export default generalSlice.reducer;
